import React, { Component } from 'react';
import { REST_API } from 'drapcode-constant';
import CustomRadio from '../../common/ui/CustomRadio';
import CardForMapping from './CardForMapping';
import ReponseDataKeyMappingToCollectionField from './ReponseDataKeyMappingToCollectionField';
export default class ResponseDataMapping extends Component {
  enableCurrentUserMapping = () => {
    const { showCurrentUserMapping, processResponseDataMapping } = this.props;
    if (processResponseDataMapping !== 'DO_NOT_PERSIST_DATA') {
      return (
        <div className="col-12">
          <hr />
          <div className="form-check mt-4 px-4">
            <CustomRadio label="Save Data in Current LoggedIn User">
              <input
                name="showCurrentUserMapping"
                type="checkbox"
                className="form-check-input"
                checked={showCurrentUserMapping}
                onChange={this.props.handleCheckboxChange}
              />
            </CustomRadio>
            <small>( It will save record in current logged in user )</small>
          </div>
        </div>
      );
    } else {
      return '';
    }
  };

  render() {
    const {
      requestMappingSelectedCollection,
      isUpdateItemWithResponse,
      handleChange,
      statusPath,
      itemsPath,
      selectedCollectionName,
      selectedMapping,
      customPrimaryKey,
      sampleResponseData,
      processResponseDataMapping,
      responseData,
      externalApiType,
      externalDatabase,
    } = this.props;
    const subtitle =
      processResponseDataMapping === 'DO_NOT_PERSIST_DATA'
        ? 'Map Collection Fields Without Persisting Record in Database'
        : processResponseDataMapping === 'SAVE_TO_COLLECTION'
        ? 'Save Response Record in Database'
        : '';

    const subtext =
      processResponseDataMapping === 'DO_NOT_PERSIST_DATA'
        ? '( It will not save record in collection data )'
        : processResponseDataMapping === 'SAVE_TO_COLLECTION'
        ? '( You can update collection and also save record in current logged in user )'
        : '';

    return (
      <CardForMapping
        color="drapcode-violet"
        title="Response Data Mapping"
        displayTitle={false}
        subtitle={subtitle}
        subtext={subtext}
      >
        <div className="row pb-3">
          {requestMappingSelectedCollection &&
            processResponseDataMapping === 'SAVE_TO_COLLECTION' && (
              <div className="col-12">
                <div className="form-check ml-4">
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      name="isUpdateItemWithResponse"
                      className="form-check-input mt-1"
                      checked={isUpdateItemWithResponse}
                      onChange={(e) => handleChange(e.target.name, e.target.checked)}
                    />
                    Update Item With Response
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </label>
                </div>
              </div>
            )}
          <ReponseDataKeyMappingToCollectionField
            handleChange={handleChange}
            itemsPath={itemsPath}
            selectedCollectionName={selectedCollectionName}
            selectedMapping={selectedMapping}
            customPrimaryKey={customPrimaryKey}
            connectorType={externalApiType}
            isDisableFields={isUpdateItemWithResponse}
            sampleResponseData={sampleResponseData}
            processResponseDataMapping={processResponseDataMapping}
            responseData={responseData}
            externalDatabase={externalDatabase}
          />
          {this.enableCurrentUserMapping()}
        </div>
      </CardForMapping>
    );
  }
}
